import { useQuery } from "@tanstack/react-query";

import { api } from "@utils/api";

import { useQueryErrorHandling } from "@hooks/useQueryErrorHandling";

import { Pagination } from "@customTypes/index";
import { Prescription } from "@customTypes/prescription";

import { prescriptionQKeys } from "./queryKeys";


const select = (res: any) => {
  // console.log(res.data);
  const pagination: Pagination = {
    page: res.data.pagination.page,
    pageCount: res.data.pagination.page_count,
    pageSize: res.data.pagination.page_size,
    total: res.data.pagination.total,
  };

  if (res.data.data.length) {
    const newData: Prescription[] = [];

    for (const i in res.data.data) {
      const {
        _id,
        prescribed_by,
        prescription_date,
        consultation_id,
        consultation_info,
        fast_consultation,
        files,
        created_at,
        updated_at,
      } = res.data.data[i];

      //? Would this separation be needed now that Prescriptions has been reworked?
      // if (fast_consultation && consultation_info) {
      //   newData.push({
      //     id: _id,
      //     consultationId: consultation_id,
      //     consultationInfo: {
      //       cId: consultation_info?.c_id,
      //       physician: {
      //         id: consultation_info?.physician?._id,
      //         fullName: consultation_info?.physician?.full_name,
      //       },
      //       date: new Date(consultation_info?.date),
      //     },
      //     prescriptionDate: new Date(prescription_date),
      //     files,
      //     prescribedBy: {
      //       id: prescribed_by?._id,
      //       fullName: prescribed_by?.full_name,
      //     },
      //     createdAt: new Date(created_at),
      //     updatedAt: new Date(updated_at),
      //     isFastConsultation: fast_consultation,
      //   });
      // } else {
      newData.push({
        id: _id,
        consultationId: consultation_id,
        consultationInfo: {
          cId: consultation_info?.c_id,
          physician: {
            id: consultation_info?.physician?._id,
            fullName: consultation_info?.physician?.full_name,
          },
          date: new Date(consultation_info?.date),
        },
        prescriptionDate: new Date(prescription_date),
        date: new Date(prescription_date),
        files,
        prescribedBy: {
          id: prescribed_by?._id,
          fullName: prescribed_by?.full_name,
        },
        createdAt: new Date(created_at),
        updatedAt: new Date(updated_at),
        isFastConsultation: fast_consultation,
      });
      // }
    }

    // console.log(newData);
    return {
      newData,
      pagination,
    };
  }
  return null;
};

interface QueryProps {
  patientId: string;
  //* Prescription always has a file so this may not be necessary
  //* But it will still be here just in case
  withFilesOnly?: boolean;
  fastConsultationOnly?: boolean;
  consultationId?: string;
  isEnabled?: boolean;
  pagination?: Partial<Pagination>;
  search?: string;
}

export const useGetPrescriptionsForPatient = ({
  patientId,
  withFilesOnly = false,
  fastConsultationOnly,
  consultationId,
  isEnabled = true,
  pagination,
  search = "",
}: QueryProps) => {
  const handleErrors = useQueryErrorHandling();

  return useQuery({
    queryKey: prescriptionQKeys.patientWithFilters(patientId, {
      withFilesOnly,
      fastConsultationOnly,
      consultationId,
      pagination,
      ...(search && { search }),
    }),
    queryFn: () => {
      return api.get(`prescription/patient/${patientId}`, {
        params: {
          only_with_files: withFilesOnly,
          ...(fastConsultationOnly !== undefined && {
            fast_consultation: fastConsultationOnly,
          }),
          ...(consultationId !== undefined && {
            consultation_id: consultationId,
          }),
          ...(search && { search }),
          ...(pagination && {
            page: pagination.page,
            page_size: pagination.pageSize,
          }),
        },
      });
    },
    select,
    enabled: isEnabled,
    staleTime: Infinity,

    onError: (res: any) => {
      console.error("[From Get Prescriptions for Patient]", res);
      handleErrors(res, "query");
    },
  });
};
